import { lazy } from 'solid-js'
import { ROUTES } from '../router-utils.js'
import { messages } from '../../pages/referral-center/referral-center-page-routing.messages.en.js'

export default {
    component: lazy(() => import('../../pages/referral-center/referral-center.jsx')),
    descriptionMessage: messages.descriptionMessage,
    path: ROUTES.REFERRAL_CENTER,
    showFooter: false,
    showHeaderMenu: false,
    showSidebar: true,
    titleMessage: messages.titleMessage,
}
